import { VoucherCategoryUpdatePage } from '@/features/voucher-category/pages/VoucherCategoryUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher-category/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherCategoryUpdatePage,
})
